import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const casePresentationDataForm: Form<Client> = {
  key: 'notice',
  fields: [
    {
      key: 'notice',
      label: 'Infos zum Fall',
      fieldTypes: 'textArea',
      rows: 10,
      xsWidth: 12,
    },
  ],
};

export default casePresentationDataForm;
